"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTripReference = IsTripReference;
const class_validator_1 = require("class-validator");
const Order_1 = require("../models/Order");
/**
 * Validates that a string is a supported trip reference.
 */
function IsTripReference(validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isTripReference",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: {
                validate(value) {
                    return (typeof value === "string" && // trip reference is a string
                        [Order_1.LEGACY_BOOKING_REFERENCE_LENGTH, Order_1.DEFAULT_BOOKING_REFERENCE_LENGTH, 25].includes(value.length) && // either 6, 8, or 25 characters long
                        /^(?:[A-Z0-9]{6,8}|[a-z0-9]{6,8}|[a-z0-9]{25})$/.test(value) // either derived from order or ride identifier, or it is pool trip id
                    );
                },
            },
        });
    };
}
//# sourceMappingURL=IsTripReference.js.map